import { Link } from "react-router-dom";
import "./Home.css";

function Home() {
  return (
    <>

      {/* ================= HERO ================= */}

      <section id="home" className="hero">

        {/* CENTER CONTENT */}

        <div className="hero-content">

          <p className="hero-small">
            SOFTWARE • AUTOMATION • TRAINING
          </p>

          <h1>
            Technology Solutions
            <br />
            <span>For Your Business</span>
          </h1>

          <p className="hero-text">
            We provide Software Development, Industrial Automation,
            Project Commissioning, Technical Support and Professional
            Training solutions for businesses and professionals.
          </p>

          <div className="hero-buttons">

            <Link
            style={{width:"40%"}}
              to="/service"
              className="btn primary"
            >
              Explore Services
            </Link>

            <Link
              to="/contact"
              className="btn secondary"
            >
              Contact Us
            </Link>

          </div>


          {/* EXPERIENCE */}

          <div className="hero-experience">

            <div>
              <strong>10+</strong>
              <span>Years Automation</span>
            </div>

            <div>
              <strong>10+</strong>
              <span>Years Software</span>
            </div>

            <div>
              <strong>5+</strong>
              <span>Core Services</span>
            </div>

          </div>

        </div>

      </section>


      {/* ================= INTRO ================= */}

      <section className="home-intro">

        <div className="section-heading">

          <p>WHAT WE DO</p>

          <h2>
            Technology & Engineering
            <span> Solutions</span>
          </h2>

          <p className="heading-text">
            Combining industrial automation expertise with modern
            software development to deliver practical and reliable
            technology solutions.
          </p>

        </div>


        <div className="intro-grid">

          {/* INDUSTRIAL AUTOMATION */}

          <div className="intro-card">

            <div className="intro-icon">
              ⚙️
            </div>

            <h3>
              Industrial Automation
            </h3>

            <p>
              PLC programming, SCADA development, HMI systems,
              automation projects, commissioning and technical
              support.
            </p>

            <Link to="/service">
              Explore Automation →
            </Link>

          </div>


          {/* SOFTWARE DEVELOPMENT */}

          <div className="intro-card">

            <div className="intro-icon">
              💻
            </div>

            <h3>
              Software Development
            </h3>

            <p>
              Modern web applications and business software using
              Java Full Stack, MERN Stack and Python technologies.
            </p>

            <Link to="/service">
              Explore Development →
            </Link>

          </div>


          {/* PROFESSIONAL TRAINING */}

          <div className="intro-card">

            <div className="intro-icon">
              🎓
            </div>

            <h3>
              Professional Training
            </h3>

            <p>
              Practical training programs in Java Full Stack,
              MERN Stack, Python, PLC, SCADA and TIA Portal.
            </p>

            <Link to="/training">
              Explore Training →
            </Link>

          </div>

        </div>

      </section>


      {/* ================= TECHNOLOGIES ================= */}

      <section className="technology-strip">

        <p>
          TECHNOLOGIES & PLATFORMS
        </p>

        <div className="technology-list">

          <span>Java</span>
          <span>Spring Boot</span>
          <span>React JS</span>
          <span>MERN</span>
          <span>Python</span>
          <span>MySQL</span>
          <span>PLC</span>
          <span>SCADA</span>
          <span>TIA Portal</span>
          <span>HMI</span>

        </div>

      </section>


      {/* ================= CTA ================= */}

      <section className="home-cta">

        <div>

          <p>
            HAVE A PROJECT IN MIND?
          </p>

          <h2>
            Let's Build Your
            <span> Solution Together.</span>
          </h2>

          <p className="cta-text">
            Whether you need an automation solution, software
            application or professional technical training,
            we are ready to help.
          </p>

        </div>

        <Link
          to="/contact"
          className="btn primary"
        >
          Start a Conversation →
        </Link>

      </section>

    </>
  );
}

export default Home;